import modalHtml from "./load-query-modal-html.html";
import {Promise} from "bluebird";
import {errorHandler} from "../../../main-app/handlers/error-handler/error-handler";
import {clientConfig} from "../../../main-app/config/client-config";

export default class LoadQueryModal {

    constructor(querySchedulingAppInputsHandler, preloaderHandler, toastHandler) {
        $("body").append(modalHtml);
        this.modal = $("#querySchedulingAppLoadQueryModal");
        this.querySchedulingAppInputsHandler = querySchedulingAppInputsHandler;
        this.preloaderHandler = preloaderHandler;
        this.tableBody = $("#loadQueryTable tbody");
        this.toastHandler = toastHandler;
        this.button = $('#loadQueryButton');
    }

    init(){
        const self = this;
        self.button.on("click", function (){
            self.show();
        })
    }

    async show() {
        const self = this;
        self.preloaderHandler.show();
        self.tableBody.empty();
        try {
            const results = await Promise.all([
                self.getUsersSavedSearches(),
                self.getUsersSavedSearchesScheduling()
            ]);
            const userSavesSearchesResponse = results[0];
            const savedSearchesScheduling = results[1];
            for (let i in userSavesSearchesResponse.savedSearches) {
                const savedSearch = userSavesSearchesResponse.savedSearches[i];
                const row = $($.parseHTML(
                    " <tr>" +
                    "                                            <td class='td-padded-right'>" +
                    "                                                <a class='load-query-modal-action query-name'>" + savedSearch.name + "</a>" +
                    "                                            </td>" +
                    "                                            <td class='td-padded-right'>" +
                    "                                                <a class='load-query-modal-action query-value'>" + savedSearch.query + "</a>" +
                    "                                            </td>" +
                    "                                            <td class='query-scheduling td-padded-right' query-scheduling='false'>" +
                    "                                                None" +
                    "                                            </td>" +
                    "                                            <td>" +
                    "                                                <a class='delete-query' query-id='" + savedSearch.id + "'>" +
                    "                                                      <i class='fas fa-times'></i>" +
                    "                                                </a>" +
                    "                                            </td>" +
                    "                                        </tr>"
                ));
                const savedSearchScheduling = savedSearchesScheduling.find(savedSearchSchedulingItem => savedSearchSchedulingItem.query.id === savedSearch.id);
                if (savedSearchScheduling) {
                    const intervalHours = savedSearchScheduling.intervalHours;
                    let text;
                    if (intervalHours < 24) {
                        text = intervalHours > 1 ? intervalHours + " hours" : intervalHours + " hour";
                    } else {
                        const days = Math.floor(intervalHours / 24);
                        const hours = intervalHours % 24;
                        const textDays = days > 1 ? days + " days, " : days + " day, ";
                        const textHours = hours > 1 ? hours + " hours" : hours + " hour";
                        text = textDays + textHours;
                    }
                    row.find(".query-scheduling").text(text)
                        .attr("query-scheduling", "true")
                        .attr("scheduling-email", savedSearchScheduling.email)
                        .attr("scheduling-interval-hours", savedSearchScheduling.intervalHours);
                }
                self.tableBody.append(row);
            }
            self.assignEvents();
            self.modal.modal("show");
        } catch (e) {
            self.handleError(e);
        }
        self.preloaderHandler.hide();
    }

    getUsersSavedSearches() {
        const self = this;
        return $.ajax({
            url: clientConfig.usersBotApi + "/saved-searches/get-by-token/" + self.querySchedulingAppInputsHandler.token.val(),
            type: 'GET',
            dataType: 'json',
            cache: false
        });
    }

    getUsersSavedSearchesScheduling() {
        const self = this;
        return $.ajax({
            url: clientConfig.appEndpoint + "app/saved-searched-scheduling/get-users-saved-searches-scheduling?token=" + self.querySchedulingAppInputsHandler.token.val(),
            type: 'GET',
            dataType: 'json',
            'headers': {
                'Content-Type': 'application/json'
            },
            cache: false,
        });
    }

    assignEvents() {
        const self = this;
        console.log(self)
        $(".load-query-modal-action").on("click", function () {
            const query = $(this).parent().parent().find(".query-value").first().text();
            const queryName = $(this).parent().parent().find(".query-name").first().text();
            const queryId = $(this).parent().parent().find(".delete-query").first().attr("query-id");
            const querySchedulingElement = $(this).parent().parent().find(".query-scheduling").first();
            const intervalHours = querySchedulingElement.attr("scheduling-interval-hours");
            const dataType = query.substring(query.indexOf(":") + 1, Math.min(query.indexOf(" "), query.length));
            const href = "https://app.diffbot.com/search/?query=" + encodeURIComponent(query) + "&referer=%2Fexcel";
            if (query !== "type:Article" && dataType !== "Article") {
                errorHandler.showModal(
                    'This data type is not supported at this time. <br>' +
                    'Click <a href="' + href + '" target="_blank">here</a> to view it in Diffbot Dashboard.'
                    , false);
                return;
            }
            self.querySchedulingAppInputsHandler.queryName.val(queryName);
            self.querySchedulingAppInputsHandler.queryId = queryId;
            self.querySchedulingAppInputsHandler.queryName.val(queryName);
            self.querySchedulingAppInputsHandler.setIntervalValue(intervalHours);
            self.querySchedulingAppInputsHandler.query.val(query);
            self.modal.modal("hide");
        });

        $(".delete-query").on("click", async function () {
            const queryId = $(this).attr("query-id");
            const row = $(this).parent().parent();
            self.preloaderHandler.show();
            try {
                await Promise.all([
                    self.deleteQuery(queryId),
                    self.deleteScheduling(queryId)
                ]);
                self.preloaderHandler.hide();
                self.toastHandler.showToast("Query deleted successfully");
                row.remove();
            } catch (e) {
                self.handleError(e);
            }
        });
    }

    deleteQuery(queryId) {
        return $.ajax({
            url: clientConfig.usersBotApi + "/saved-searches/delete/" + queryId,
            type: 'DELETE',
            cache: false,
        });
    }

    deleteScheduling(queryId) {
        const self = this;
        const data = {
            "token": self.querySchedulingAppInputsHandler.token.val(),
            "queryId": queryId,
        };
        return $.ajax({
            url: clientConfig.appEndpoint + "app/saved-searched-scheduling/delete",
            type: 'POST',
            dataType: 'json',
            'headers': {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(data),
            cache: false,
        });
    }

    handleError(e) {
        console.error(e);
        let message = "There was an error processing the request.";
        if (e.status >= 400 && e.status < 500) {
            message = message + " Error: " + e.responseText;
        }
        errorHandler.showModal(message, false);
    }
}